import { Outlet, Link, useLocation } from 'react-router-dom'
import { FileText, Settings, Home, BookOpen } from 'lucide-react'

export function Layout() {
  const location = useLocation()
  const isAdmin = location.pathname.startsWith('/admin')
  const isBlog = location.pathname.startsWith('/blog')

  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-white border-b border-gray-200 safe-top">
        <div className="max-w-4xl mx-auto px-4 h-14 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-primary-600 font-semibold">
            <FileText className="w-6 h-6" />
            <span className="text-lg">DocSigner</span>
          </Link>
          <nav className="flex items-center gap-2">
            <Link
              to="/"
              className={`p-2 rounded-lg transition-colors ${
                location.pathname === '/' ? 'bg-primary-100 text-primary-600' : 'text-gray-600 hover:bg-gray-100'
              }`}
              title="Início"
            >
              <Home className="w-5 h-5" />
            </Link>
            <Link
              to="/blog"
              className={`p-2 rounded-lg transition-colors ${
                isBlog ? 'bg-primary-100 text-primary-600' : 'text-gray-600 hover:bg-gray-100'
              }`}
              title="Blog"
            >
              <BookOpen className="w-5 h-5" />
            </Link>
            <Link
              to="/admin"
              className={`p-2 rounded-lg transition-colors ${
                isAdmin ? 'bg-primary-100 text-primary-600' : 'text-gray-600 hover:bg-gray-100'
              }`}
              title="Administração"
            >
              <Settings className="w-5 h-5" />
            </Link>
          </nav>
        </div>
      </header>

      <main className="flex-1 flex flex-col">
        <Outlet />
      </main>

      <footer className="bg-gray-900 text-white py-12 safe-bottom">
        <div className="max-w-4xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            <div>
              <h3 className="font-semibold mb-3">DocSigner</h3>
              <p className="text-gray-400 text-sm mb-4">
                Plataforma para gerar e assinar minutas de resolução de contrato de seguro online.
              </p>
              <p className="text-gray-400 text-sm">
                <strong className="text-gray-300">Contacto:</strong><br />
                <a href="mailto:cessarcontrato@pedrorualves.eu" className="hover:text-white transition-colors">
                  cessarcontrato@pedrorualves.eu
                </a>
              </p>
            </div>
            <div>
              <h3 className="font-semibold mb-3">Modelos Disponíveis</h3>
              <ul className="text-gray-400 text-sm space-y-2">
                <li><Link to="/" className="hover:text-white transition-colors">Seguro Automóvel</Link></li>
                <li><Link to="/" className="hover:text-white transition-colors">Seguro Habitação</Link></li>
                <li><Link to="/" className="hover:text-white transition-colors">Outros Seguros</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="font-semibold mb-3">Recursos</h3>
              <ul className="text-gray-400 text-sm space-y-2">
                <li><Link to="/blog" className="hover:text-white transition-colors">Blog</Link></li>
                <li><Link to="/blog/como-cessar-contrato-seguro" className="hover:text-white transition-colors">Como Resolver Contrato</Link></li>
                <li><Link to="/termos" className="hover:text-white transition-colors">Termos e Privacidade</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 text-center text-sm text-gray-500">
            <p className="mb-2">Processamento 100% local. Os seus dados nunca saem do dispositivo.</p>
            <p className="mb-4">© 2026 DocSigner. Minuta resolução contrato seguro online.</p>
            <div className="flex items-center justify-center gap-2 text-gray-600">
              <span>Desenvolvido com</span>
              <a 
                href="https://www.cloudflare.com/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1 hover:text-orange-500 transition-colors"
              >
                <svg className="w-4 h-4" viewBox="0 0 64 64" fill="currentColor">
                  <path d="M42.5 37.5c.5-1.7.3-3.3-.6-4.5-.8-1.1-2.1-1.8-3.6-1.9l-20.8-.3c-.2 0-.4-.1-.5-.2-.1-.2-.1-.4 0-.5.1-.2.3-.4.5-.4l21-.3c3.5-.2 7.3-3 8.5-6.5l1.5-4.4c.1-.2.1-.4 0-.6-2.1-9.5-10.5-16.6-20.5-16.6-9.3 0-17.2 6.1-20 14.5-.6-.4-1.3-.7-2.1-.7-2.3 0-4.2 1.9-4.2 4.2 0 .5.1 1 .2 1.4C.6 22.3 0 24.6 0 27c0 7.2 5.8 13 13 13h28.3c.3 0 .6-.2.7-.5l.5-2z"/>
                  <path d="M52.4 21.7c-.3 0-.6 0-.9.1-.2 0-.4.2-.5.4l-1.1 3.8c-.5 1.7-.3 3.3.6 4.5.8 1.1 2.1 1.8 3.6 1.9l4.4.3c.2 0 .4.1.5.2.1.2.1.4 0 .5-.1.2-.3.4-.5.4l-4.6.3c-3.5.2-7.3 3-8.5 6.5l-.4 1.3c-.1.3.1.6.4.6H59c2.8 0 5-2.2 5-5 0-7.9-6.4-14.3-11.6-14.8z"/>
                </svg>
                <span>Cloudflare</span>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}
